import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    BubbleReactionsDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getHitArea
} from "../../../../helpers/theme/control";
import {
    webStyle
} from "../../../../utils";

export const BUBBLE_REACTIONS_MAX_EMOJIS = 3;

const stylesheet = StyleSheet.create({
    container: {
        justifyContent: "center",
        position: "relative",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    chip: {
        justifyContent: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    add: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    item: {
        justifyContent: "center",
        alignItems: "center",
        ...webStyle({
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    addSurface: {
        justifyContent: "center",
        alignItems: "center",
        borderStyle: "solid"
    },
    row: {
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap"
    },
    surface: {
        alignItems: "center",
        flexDirection: "row",
        borderStyle: "solid"
    },
    strip: {
        position: "absolute",
        flexDirection: "row",
        borderStyle: "solid"
    },
    count: {
        fontVariant: [
            "tabular-nums"
        ]
    }
});

export const useStyles = ({
    marginHorizontal,
    controlHeights,
    shapeConfigs,
    touchTargets,
    isPressable,
    pointerType,
    spaces,
    align,
    side
}: BubbleReactionsDynamicStyleType) => {
    const chipHeight = controlHeights.small - shapeConfigs.chipHeightOffset;

    const hitArea = getHitArea({
        visualSize: chipHeight,
        touchTargets,
        pointerType
    });

    const extra = isPressable ? (hitArea.minHeight - chipHeight) / 2 : 0;

    const styles = {
        container: {
            marginTop: side === "bottom" ? -chipHeight / 2 - extra : -extra,
            marginBottom: side === "top" ? -chipHeight / 2 - extra : -extra,
            alignSelf: align === "start" ? "flex-start" : "flex-end",
            minHeight: isPressable ? hitArea.minHeight : chipHeight,
            zIndex: shapeConfigs.layers.raised,
            gap: spaces.spacingXs,
            marginHorizontal
        } as Mutable<ViewStyle>
    };

    return styles;
};

export default stylesheet;
